import React, { Component } from 'react';
import * as ct from '../../shared/ClientConstants';

export class VerticalPlayerId extends Component {
  render() {
    return (
      <div>
        <div
          className="row"
          style={{ backgroundColor: this.props.backgroundColor }}
        >
          <div className="col-12">
            <img
              src={'/api/file/avatar?proCode=' + this.props.proCode}
              alt="profile"
              style={{
                width: this.props.limitWidth || '100%',
                marginLeft: this.props.limitMargin || '0%',
                marginRight: this.props.limitMargin || '0%',
              }}
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col-12"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <a href={'/user/' + this.props._id}>{this.props.name}</a>
          </div>
        </div>
      </div>
    );
  }
}

export default VerticalPlayerId;
